var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:[_vm.baseCss, 'cursor-wait'],style:({zIndex: _vm.zIndex})},[_c('icon',{class:['animate-spin'],style:({fontSize: (_vm.spinnerSize + "em")}),attrs:{"provider":_vm.iconProvider,"name":"loading","color":_vm.spinnerColor,"color-lightness":_vm.spinnerColorLightness}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b83b190","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/loading-overlay/loading-overlay.vue
// module id = null
// module chunks = 